/**
 * スタッフ紹介・おすすめ物件カード：title / features / comment を行ごとに高さ揃え（jquery-match-height）
 */
import $ from 'jquery';
import 'jquery-match-height';

const MATCH_SELECTORS = [
	'.staffRecommendCard__title',
	'.staffRecommendCard__features',
	'.staffRecommendCard__comment',
];

function debounce(fn, ms) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(null, args), ms);
	};
}

function getRecommendListRoot() {
	const panel = document.getElementById('staff-tab-panel-property');
	if (!panel || panel.hidden) return null;
	return panel.querySelector('.staffRecommendList');
}

export function updateStaffRecommendCardMatchHeight() {
	const list = getRecommendListRoot();
	if (!list) return;

	MATCH_SELECTORS.forEach(function (selector) {
		const $els = $(list).find(selector);
		if (!$els.length) return;
		$els.matchHeight('remove');
		$els.matchHeight({ byRow: true });
	});
}

export function initStaffRecommendCardMatchHeight() {
	if (!document.querySelector('.staffRecommendList')) return;

	const update = () => updateStaffRecommendCardMatchHeight();

	update();

	const onResize = debounce(update, 150);
	window.addEventListener('resize', onResize);

	if (document.fonts?.ready) {
		document.fonts.ready.then(update);
	}

	const list = document.querySelector('.staffRecommendList');
	if (list && typeof ResizeObserver !== 'undefined') {
		const ro = new ResizeObserver(debounce(update, 100));
		ro.observe(list);
	}
}
